module.exports = __webpack_public_path__ + "img/img-seeyou.0976027c.png";